import { useState } from 'react';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import Icon from '../../components/AppIcon';
import DeliverabilityTester from './components/DeliverabilityTester';
import BlacklistMonitor from './components/BlacklistMonitor';
import ListCleanerVerifier from './components/ListCleanerVerifier';

const DataIntelligenceHub = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState('deliverability');

  const tabs = [
    { id: 'deliverability', label: 'Deliverability Tester', icon: 'Mail' },
    { id: 'blacklist', label: 'Blacklist Monitor', icon: 'Shield' },
    { id: 'cleaner', label: 'List Cleaner / Verifier', icon: 'CheckCircle' }
  ];

  return (
    <div className="flex h-screen bg-background overflow-hidden">
      <Sidebar 
        collapsed={isSidebarCollapsed} 
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        currentSection="Data Intelligence"
      />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onMenuClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)} />
        
        <main className="flex-1 overflow-y-auto">
          <div className="container mx-auto px-6 py-8">
            <Breadcrumbs
              items={[
                { label: 'Home', path: '/' },
                { label: 'Data Intelligence Hub', path: '/data-intelligence-hub' }
              ]}
            />

            <div className="flex items-center justify-between mb-8">
              <div>
                <h1 className="text-3xl font-heading font-bold text-foreground mb-2">
                  Data Intelligence Hub
                </h1>
                <p className="text-muted-foreground">
                  Advanced analytics, testing, and verification tools for email marketing optimization
                </p>
              </div>
            </div>

            {/* Tab Navigation */}
            <div className="bg-card rounded-lg border border-border mb-6">
              <div className="flex border-b border-border overflow-x-auto">
                {tabs?.map((tab) => (
                  <button
                    key={tab?.id}
                    onClick={() => setActiveTab(tab?.id)}
                    className={`flex items-center gap-2 px-6 py-4 text-sm font-medium transition-colors whitespace-nowrap ${
                      activeTab === tab?.id
                        ? 'text-primary border-b-2 border-primary bg-primary/5' :'text-muted-foreground hover:text-foreground hover:bg-muted'
                    }`}
                  >
                    <Icon name={tab?.icon} size={18} />
                    {tab?.label}
                  </button>
                ))}
              </div>

              {/* Tab Content */}
              <div className="p-6">
                {activeTab === 'deliverability' && <DeliverabilityTester />}
                {activeTab === 'blacklist' && <BlacklistMonitor />}
                {activeTab === 'cleaner' && <ListCleanerVerifier />}
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default DataIntelligenceHub;